import {Checkbox, Divider, CircularProgress} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import React, {useState} from 'react';
import {localized} from '../../../../state/i18n/i18n';
import {GetColorByIndex} from '../../../../utilities/colors';
import DeviceContentContainer from '../teracom-device-content-container';
import DeviceMenuItem from './device-menu-item';
import './device-menu.scss';

export default ({devices, setDevices, devicesData}) => {
  const selectAllDevices = (e) => {
    const selected = e.target.checked;
    const newDevices = devices.map((device) => ({
      ...device,
      selected,
    }));
    setDevices(newDevices);
  };

  const selectedAll = Array.isArray(devices) && devices.length && devices.every((device) => device.selected);

  const [showDeviceGraph, setShowDeviceGraph] = useState(false);

  const showNavigationButton = () => (
    <div onClick={showGraph} className="pageBottomNavigator flexDirectionRow">
      {showDeviceGraph && <ArrowBackIosIcon className="arrowBackLeft"></ArrowBackIosIcon>}

      {showDeviceGraph ? localized('BackToDevices') : localized('ContinueToGraphs')}

      {!showDeviceGraph && <ArrowForwardIosIcon className="arrowForwardRight"></ArrowForwardIosIcon>}
    </div>
  );

  const showGraph = () => {
    setShowDeviceGraph(showDeviceGraph ? false : true);
  };

  const showDeviceMenuTopContainer = () => (
    <div className={'topContainer devicesTableTopContainer padding'}>
      <div className="width100">
        <div className="boldText">{localized('Devices')}</div>
        <div className="availableDevices">{localized('AvailableDevices')}</div>
      </div>
    </div>
  );

  const getUserDevices = () => {
    if (!Array.isArray(devices)) {
      return <div className="emptyMessageSettings">{localized('LoadingDevices')}</div>;
    } else {
      if (devices.length > 0) {
        return (
          <div className="flexDirectionRow flexWrap spaceEvenly scroll paddingBottom">{devices.map(mapDeviceItem)}</div>
        );
      }
      return <div className="emptyMessageSettings">{localized('NoDevices')}</div>;
    }
  };

  const menuItemClick = (deviceId) => {
    if (Array.isArray(devices)) {
      const newDevices = [...devices];
      const selectedDevice = newDevices.find((device) => device.deviceId === deviceId);
      selectedDevice.selected = !selectedDevice.selected;
      setDevices(newDevices);
    }
  };
  const mapDeviceItem = (d, index) => (
    <DeviceMenuItem
      onMenuItemClicked={menuItemClick}
      checkBoxColor={GetColorByIndex(index)}
      selected={d.selected}
      name={d.deviceId}
      active={d.active}
      key={d.deviceId}
      identifier={d.deviceId}
    />
  );

  const showDeviceMenuItems = () => (
    <div>
      <Divider />
      <div className="chooseAllOrDismissContainer">
        <div className="chooseAllOrDismiss">{localized('ChooseOrDismissAll')}</div>
        <Checkbox onClick={selectAllDevices} color={'primary'} className="checkBoxStyle" checked={selectedAll} />
      </div>

      <Divider />
      {devices === null && <CircularProgress className="spinner" />}

      {getUserDevices()}
    </div>
  );

  return (
    <div>
      {!showDeviceGraph && showDeviceMenuTopContainer()}
      {!showDeviceGraph && showDeviceMenuItems()}
      {showDeviceGraph && (
        <div className="flexDirectionRow flexWrap spaceBetween scroll paddingBottom">
          <DeviceContentContainer devices={devices} devicesData={devicesData} />
        </div>
      )}
      {showNavigationButton()}
    </div>
  );
};
